
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { CLARITY_PROJECT_ID } from '../../project_config';
import Footer from "../common/footer/Footer";
import { FooterButton } from "../common/footer/FooterButton";
import Header from "../common/header/Header";
import SeoMeta from "../common/seo/SeoMeta";
import HeroSection from "./HeroSection";
import HomeExpertisesSection from "./HomeExpertisesSection";
import CustomCarousels from "./CustomCarousels";

export default function Home() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 768);
	useEffect(() => {
		const onResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	return (
		<div>
			<SeoMeta
				title="همراهتیم — کارگاه، وبینار و همراهی روان‌شناسی"
				description="پلتفرم آموزش و همراهی روان‌شناسی همراهتیم: کارگاه، وبینار، کلیپ و مقالات تخصصی."
				path="/"
				type="website"
			/>

			{isDesktop ? (
				<div className="flex min-h-screen flex-col justify-between bg-lightCta">
					<div>
						<Header isDesktop={isDesktop} />
						<HeroSection isDesktop={isDesktop} />
						<div className="mx-auto w-full max-w-[1200px] px-4 pb-4 pt-2">
							<HomeExpertisesSection isDesktop={isDesktop} />
						</div>
						<div className="w-full pt-2 pb-3">
							<CustomCarousels isDesktop={isDesktop} />
						</div>
						<div className="pb-6" aria-hidden />
					</div>
					<Footer isDesktop={isDesktop} isHomePage />
				</div>
			) : (
				<div className="min-h-screen bg-[#F0F6FC] pb-20">
					<Header isDesktop={isDesktop} />
					<HeroSection isDesktop={isDesktop} />
					<div className="mx-auto w-full max-w-[1200px] px-4 pb-4 pt-2">
						<HomeExpertisesSection isDesktop={isDesktop} />
					</div>
					<div className="w-full pt-2 pb-3">
						<CustomCarousels isDesktop={isDesktop} />
					</div>
					<div className="pb-6" aria-hidden />
					<Footer isDesktop={isDesktop} activeButton={FooterButton.HOME} isHomePage />
				</div>
			)}
		</div>
	);
}
